import PageShell from "../components/PageShell";
import { Shield } from "lucide-react";

const LAST_UPDATED = "June 2026";

export default function Privacy() {
  return (
    <PageShell
      title="Privacy Policy"
      subtitle={`Last updated: ${LAST_UPDATED}`}
      icon={Shield}
      testid="privacy-page"
    >
      <div className="font-ui space-y-8 rounded-3xl border border-border bg-background/50 p-8 leading-relaxed text-foreground/90 backdrop-blur-md md:p-12">
        <section>
          <p className="text-base">
            Clarity Bible ("we", "us") is an immersive Bible reading app. We respect your
            privacy and built Clarity Bible to keep your personal data on your own device
            wherever possible. This policy explains what is and isn't collected.
          </p>
        </section>

        <section>
          <h2 className="font-serif-display mb-2 text-xl text-primary">Data stored on your device</h2>
          <p>
            Your reading progress, streaks, bookmarks, highlights, prayer journal entries,
            sermon notes, memorization cards and app settings are stored locally on your
            device (browser local storage / on-device storage). This information stays on
            your device and is not transmitted to us.
          </p>
        </section>

        <section>
          <h2 className="font-serif-display mb-2 text-xl text-primary">Bible content & artwork</h2>
          <p>
            Bible text and chapter artwork are delivered from our servers so the app can
            display them. These requests do not require an account and are not used to
            identify you.
          </p>
        </section>

        <section>
          <h2 className="font-serif-display mb-2 text-xl text-primary">Notifications</h2>
          <p>
            If you enable reading reminders, notifications are scheduled locally on your
            device. We do not send remote push messages and we do not collect a device
            token.
          </p>
        </section>

        <section>
          <h2 className="font-serif-display mb-2 text-xl text-primary">Payments</h2>
          <p>
            Optional Clarity Bible Premium subscriptions are processed by Stripe. Payment
            details are entered directly with Stripe and handled under Stripe's privacy
            policy. We do not store your card information.
          </p>
        </section>

        <section>
          <h2 className="font-serif-display mb-2 text-xl text-primary">Family sharing (optional)</h2>
          <p>
            If you choose to join a Family group, the group code, a display name you
            provide, and prayers you share are stored so they can be shown to others in
            your group. Don't share sensitive personal information you don't want group
            members to see.
          </p>
        </section>

        <section>
          <h2 className="font-serif-display mb-2 text-xl text-primary">Children</h2>
          <p>
            Clarity Bible is suitable for all ages and does not knowingly collect personal
            information from children.
          </p>
        </section>

        <section>
          <h2 className="font-serif-display mb-2 text-xl text-primary">Your choices</h2>
          <p>
            You can clear all locally stored data at any time by clearing the app's
            storage in your device or browser settings.
          </p>
        </section>

        <section>
          <h2 className="font-serif-display mb-2 text-xl text-primary">Contact</h2>
          <p>
            Questions about this policy? Contact us at{" "}
            <a href="mailto:support@verseflow.app" className="text-primary hover:underline">
              support@verseflow.app
            </a>
            .
          </p>
        </section>
      </div>
    </PageShell>
  );
}
